<template>
  <dialog
    ref="dialog"
    class="dialog"
    @click="click($event)"
    :style="[modelValue ? 'z-index: 999;' : 'z-index: 0;  visibility: hidden;']"
  >
    <div v-if="modelValue" class="dialog-box">
      <div class="close" @click="closeDialog()"></div>
      <div class="dialog-action">
        <p>{{ MEDIA_NAME[mediaType] }}アカウント{{ title }}</p>
        <p>@を除いたアカウント名を入力してください</p>
        <Form
          class="form"
          :validationSchema="validationSchema"
          v-slot="{ meta: { valid } }"
        >
          <div class="dialog-text-area">
            <Field
              type="text"
              v-model="name"
              name="name"
              placeholder="アカウント名"
              class="text-field"
              tabindex="1"
            />
            <div>
              <ErrorMessage name="name" v-slot="{ message }"
                ><span class="error">{{ message }}</span></ErrorMessage
              >
            </div>
          </div>
          <div class="dialog-button-area">
            <common-button
              v-if="!loading"
              :data="{
                status: !valid ? 2 : 0,
                button: accountName ? `更新` : `登録`,
              }"
              @click="!valid ? '' : onDialogAction(true)"
            ></common-button>
            <common-button
              v-if="accountName && !loading"
              :data="{
                status: 3,
                button: `削除`,
              }"
              @click="onDialogAction(false)"
            ></common-button>
            <div v-if="loading">
              <img src="../assets/loading.gif" class="loading" />
            </div>
          </div>
        </Form>
      </div>
    </div>
  </dialog>
  <div class="l-modal" v-if="modelValue">
    <div :class="[modelValue ? 'l-modal__bg' : '']"></div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import * as yup from "yup";
import { Form, Field, ErrorMessage } from "vee-validate";
import CommonButton from "./CommonButton.vue";
import { updateUserSnsAccountRequest } from "../types/apiRequest";
import { UserInfoStore } from "../store/UserInfoStore";
import { MEDIA_NAME } from "../consts/common";
import router from "../router";

// APIを公開
defineExpose({
  openDialog,
  closeDialog,
});

export type Props = {
  modelValue: boolean;
  mediaType: number;
  accountName: string;
};

// dialogの参照を保持する変数
const dialog = ref<HTMLDialogElement | null>(null);
// const open = ref(false);
const userInfoStore = UserInfoStore();
const emit = defineEmits(["update:modelValue"]);
const props = defineProps<Props>();
const name = ref("");
const title = ref("登録");

const loading = ref(false);
// const message = ref("");
const validationSchema = ref(
  yup.object().shape({
    name: yup
      .string()
      .trim()
      .required("アカウント名は必須です")
      .min(1)
      .matches(/^[ -~]+$/, "アカウント名は@を除き半角で入力してください")
      .matches(/^(?!.*@).*$/, "アカウント名は@を除き半角で入力してください")
      .label("アカウント名"),
  })
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const click = async ($event: any) => {
  if (!$event || !$event.target) {
    name.value = "";
    title.value = "登録";
    emit("update:modelValue", false);
    dialog?.value?.close();
  }
};

// //ダイアログのクリックイベント
// contactDialog.addEventListener('click', (event) => {

//   if(!event || !event.target || (event.target as HTMLElement).closest('.dialog-action') === null) {
//     dialog?.value?.close();
//   }
// });

async function registSnsAccount() {
  loading.value = true;
  const req: updateUserSnsAccountRequest = {
    media_type: props.mediaType,
    account_name: name.value,
  };
  await userInfoStore.updateUserSnsAccount(req);
  emit("update:modelValue", false);
  name.value = "";
  title.value = "登録";
  loading.value = false;

  dialog?.value?.close();
}

async function updateUserSnsInfo() {
  loading.value = true;
  const req: updateUserSnsAccountRequest = {
    media_type: props.mediaType,
    account_name: name.value,
  };
  await userInfoStore.updateUserSnsAccount(req);
  name.value = "";
  title.value = "登録";
  emit("update:modelValue", false);
  loading.value = false;
  // 案件詳細→ユーザー登録から遷移の場合は案件詳細に戻る
  if (window.history.state.back == "/sign-up") {
    router.go(-2);
  }
  dialog?.value?.close();
}

async function deleteSnsAccout() {
  loading.value = true;
  await userInfoStore.deleteUserSnsAccount(props.mediaType);
  emit("update:modelValue", false);
  loading.value = false;
  title.value = "登録";
  dialog?.value?.close();
}

// 外部に公開するAPI。ダイアログを開いて、終了
function openDialog() {
  // open.value = true;
  dialog?.value?.showModal();
}
function closeDialog() {
  // open.value = true;
  name.value = "";
  dialog?.value?.close();
  emit("update:modelValue", false);
  title.value = "登録";
}

// ボタンが押されたときに呼ばれるコールバック
async function onDialogAction(action: boolean) {
  if (action) {
    if (props.accountName) updateUserSnsInfo();
    else await registSnsAccount();
  } else {
    await deleteSnsAccout();
    dialog?.value?.close();
  }
  emit("update:modelValue", false);
}

watch<boolean>(
  () => props.modelValue,
  () => {
    name.value = props.accountName;
    title.value = props.accountName ? "更新" : "登録";
  }
);
</script>
<style scoped lang="scss">
@import "../assets/style/_variables.scss";
.l-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}
.l-modal__bg {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.75);
  position: fixed;
  top: 0;
  left: 0;
  text-align: center;
  > div {
    width: 100%;
    position: fixed;
    bottom: 64px;
    text-decoration-line: underline;
    color: $white;
    font-weight: 300;
    font-size: $FONT_SIZE_M;
  }
}
.dialog {
  overflow: auto;
  text-align: center;
  width: 315px;
  border-radius: 10px;
  position: relative;
  z-index: 9999;
  border-width: 0;
}
.dialog-error-message {
  color: red;
}
.dialog-button-area {
  padding-top: 10px;
  width: 200px;
  margin: 0 auto;
}
.dialog-text-area {
  width: 100%;
  height: 50px;
  margin: 0 auto;
  padding-bottom: 50px;
}
.btn-close {
  margin-right: 10px;
  width: 70px;
  appearance: none;
  border: 0;
  border-radius: 5px;
  background: #b2b2b2;
  color: $white;
  padding: 8px 12px;
  font-size: $FONT_SIZE_M;
}
.dialog-action {
  text-align: center;
  p:nth-child(1) {
    font-style: normal;
    font-weight: 600;
    font-size: $FONT_SIZE_S;
    line-height: 150%;
    /* ボックスの高さと同一、または18px */
    align-items: center;
    text-align: center;

    color: #000000;
  }

  p:nth-child(2) {
    font-style: normal;
    font-weight: 300;
    font-size: 10px;
    line-height: 150%;
    /* または15px */
    align-items: center;
    text-align: center;

    color: #000000;
  }
  .error {
    color: red;
    text-align: center;
    margin: 0;
    font-size: $FONT_SIZE_S;
  }
  .text-field {
    width: 307px;
    height: 48px;
    border: 1px solid #777777;
    border-radius: 2px;
    background-color: $white;
    padding: 0 0 0 8px;
    font-size: $FONT_SIZE_M;
  }
}
.loading {
  width: 10%;
  height: 10%;
}
.close {
  position: absolute;
  display: block;
  right: 0px;
  top: 0px;
  width: 9px;
  height: 9px;
  padding: 15px;
}
.close::before,
.close::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2px;
  height: 14px;
  background: #333;
}
.close::before {
  transform: translate(-50%, -50%) rotate(45deg);
}

.close::after {
  transform: translate(-50%, -50%) rotate(-45deg);
}
</style>
